import _curry from "ramda/es/curry";
import _always from "ramda/es/always";
import _is from "ramda/es/is";
import _unless from "ramda/es/unless";

var defaultToEmptyString = _unless(_is(String), _always(''));

export default _curry(function (a, b) {
  return defaultToEmptyString(a).localeCompare(defaultToEmptyString(b));
});